import { Link } from "react-router-dom";
import { useSeo } from "@/lib/useSeo";
import "@/pages/legal.css";

const BOOK_URL = "https://calendar.app.google/MFyPpbRo7HG92Q1YA";

export default function LegalLayout({ title, updated, lead, sections, seo }) {
  useSeo(seo);
  return (
    <div className="legal-page">
      <nav>
        <div className="wrap">
          <Link to="/" className="logo">Craig Maloney</Link>
          <a href={BOOK_URL} target="_blank" rel="noopener noreferrer" className="btn-blue">
            Book a Call
          </a>
        </div>
      </nav>

      <header className="head">
        <div className="wrap">
          <h1>{title}</h1>
          <div className="updated">Last updated: {updated}</div>
          <div className="disclaimer">
            This page is a general template provided for convenience and is not
            legal advice. Please have it reviewed by qualified counsel and adjust
            it to reflect your actual practices before relying on it.
          </div>
        </div>
      </header>

      <article>
        <div className="wrap">
          {lead && <p className="lead">{lead}</p>}
          {sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2>{s.heading}</h2>
              {s.paragraphs?.map((p, pi) => (
                <p key={pi}>{p}</p>
              ))}
              {s.bullets && (
                <ul>
                  {s.bullets.map((b, bi) => (
                    <li key={bi}>{b}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </article>

      <footer>
        <div className="wrap">
          <div>© 2026 Craig Maloney Inc. All rights reserved.</div>
          <div className="legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
